import axios from 'axios'

const state = {
  user: {}
}

const getters = {
  getUser(state) {
    return state.user
  },

  can: state => role => {
    if (state.user.roles) {
      return state.user.roles.find(p => {
        return p === role || p === 'SUPPORT' || p === 'ALL_HONEY'
      })
    } else {
      return false
    }
  }
}

const mutations = {
  setUser(state, principal) {
    state.user = principal
  }
}

const actions = {
  async getUserPrincipal({ commit }) {
    let response = await axios.get('/api/v1/auth/principal')
    let principal = response.data
    commit('setUser', principal)
    return principal
  },

  async logout() {
    await axios.post('/logout')
    window.location.href = '/logout'
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
